module.exports = __webpack_public_path__ + "img/Papp.19dddde3.png";